import { Injectable } from "@angular/core";
import { UserLogin } from "./../../models/cms/user-login";

@Injectable()
export class LocalStorageService {
    Write(key: string, value: any) {
        if (value) {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    }
      
    Read(key: string){
        let value: string = localStorage.getItem(key);

        if (value && value != "undefined" && value != "null") {
            let userLoginParsed = Helper.toInstance(new UserLogin(), JSON.parse(value));
            return userLoginParsed;
        }
        return null;
    }
    Remove(key: string) {
        localStorage.removeItem(key);
    }
}
class Helper {
    static toInstance<T>(obj: T, json: string): T {
        var jsonObj = JSON.parse(json);

        if (typeof obj["fromJSON"] === "function") {
            obj["fromJSON"](jsonObj);
        }
        else {
            for (var propName in jsonObj) {
                obj[propName] = jsonObj[propName]
            }
        }
        return obj;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/local-storage.ts